import type { Product } from "~/models/Product"
import { ref } from "vue"
import { useStoreTypeStore } from "~/stores/StoreTypeStore"
import { useShopCartStore } from "~/stores/shopCartStore"
import { useNotification } from "~/composables/ShowNotification"
import { useRouter } from "vue-router"
import { useProvinceSelection } from "~/composables/useProvinceSelection"
import type { Combo } from "~/models/Combo"

const getImageId = (image: any) => {
    if (image && "id" in image) {
        return image.id
    } else {
        return ""
    }
}
export function useProductCardData(product: Product) {
    const shopCartStore = useShopCartStore()
    const notify = useNotification()
    const router = useRouter()
    const storeTypeStore = useStoreTypeStore()
    const { type } = storeToRefs(storeTypeStore)

    // Province selection functionality
    const {
        isValidProvinceSelected,
        selectedProvince,
        openProvinceModalWithAction,
    } = useProvinceSelection()

    const slide = ref(
        product?.images?.length > 0 ? getImageId(product.images[0]) : -1
    )
    const ranting = ref(3)
    const quantity = ref(getDefaultQuantity())

    const executeAddToCart = (
        product: Product,
        quantity: number,
        province: string
    ) => {
        const form = {
            model: product.instance_of == "Product" ? "product" : "combo",
            province: province,
            quantity: quantity,
            productible: product.id,
            type: type.value,
            terms: undefined,
        }

        const options = {
            headers: {
                "X-Store-Context": JSON.stringify({
                    store_id: product.store,
                    product_id: product.id,
                    product_slug: product.slug,
                }),
            },
        }

        return shopCartStore
            .addToCart(form, options)
            .then((res: any) => {
                notify("positive", res.message)
                return res
            })
            .catch((error: any) => {
                notify("negative", error._data.message)
                throw error
            })
    }

    const add = (product: Product, quantity: number) => {
        if (!isValidProvinceSelected.value) {
            openProvinceModalWithAction((province: string) => {
                executeAddToCart(product, quantity, province)
            })
            return Promise.resolve()
        }

        return executeAddToCart(product, quantity, selectedProvince.value)
    }

    const show = (product: Product | Combo) => {
        product.instance_of == "Product"
            ? router.push(`/products/${product.slug}`)
            : router.push(`/combos/${product.slug}`)
    }

    function getDefaultQuantity() {
        return product.min_quantity || 1
    }

    return {
        slide,
        ranting,
        quantity,
        add,
        show,
    }
}
